<template>
  <v-dialog v-model="dialog" max-width="400px">
    <v-card>
      <v-card-title class="headline font-weight-bold">
        Sincronizar Dados
      </v-card-title>

      <v-card-text class="text-body-2">
        Serão sincronizados os seguintes dados:
        <ul class="mt-2">
          <li>⚙️ Configurações</li>
          <li>👨‍🌾 Produtores</li>
          <li>📋 Visitas</li>
          <li>🖼️ Mídias</li>
        </ul>
        <p class="mt-3">Deseja continuar com a sincronização agora?</p>
      </v-card-text>

      <v-card-actions class="justify-end">
        <v-btn :disabled="sincronizando" text color="grey" @click="dialog = false">
          Cancelar
        </v-btn>
        <v-btn
          color="info"
          class="font-weight-bold"
          :loading="sincronizando"
          @click="sincronizar()"
        >
          Sincronizar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  computed: mapState("visitaTecnica",["sincronizando"]),
  data: () => ({
    dialog: true,    
  }),
  watch: {
    dialog: function (open) {
      if (!open) {
        this.$router.go(-1);
      }
    },
  },
  methods: {
    ...mapActions("visitaTecnica", ["sincronizarDados"]),
    async sincronizar() {
      await this.sincronizarDados();      
      this.$router.go(-1);
    },
    isMobile() {
      return this.$mq == "sm";
    },
  },
};
</script>

<style>
</style>